const router = {
  path: '/markup/enterprise',
  name: 'MarkupEnterprise',
  meta: { title: '企业实名认证', type: 'user' },
  component: () => import('@/components/Layout'),
  children: [
    {
      path: '/markup/enterprise/card',
      name: 'MarkupEnterpriseCard',
      meta: { title: '填写车卡信息', type: 'user' },
      component: () => import('@/views/markup/enterprise/card')
    },
    {
      path: '/markup/enterprise/cert',
      name: 'MarkupEnterpriseCert',
      meta: { title: '填写企业信息', type: 'user' },
      component: () => import('@/views/markup/enterprise/cert')
    },
    {
      path: '/markup/enterprise/cert-image',
      name: 'MarkupEnterpriseCertImage',
      meta: { title: '上传企业证件照片', type: 'user' },
      component: () => import('@/views/markup/enterprise/cert-image')
    },
    {
      path: '/markup/enterprise/user',
      name: 'MarkupEnterpriseUser',
      meta: { title: '责任人身份信息', type: 'user' },
      component: () => import('@/views/markup/enterprise/user')
    },
    {
      path: '/markup/enterprise/paper',
      name: 'MarkupEnterprisePaper',
      meta: { title: '责任人身份信息', type: 'user' },
      component: () => import('@/views/markup/enterprise/paper')
    },
    {
      path: '/markup/enterprise/idcard',
      name: 'MarkupEnterpriseIdcard',
      meta: { title: '责任人身份信息', type: 'user' },
      component: () => import('@/views/markup/enterprise/idcard')
    },
    {
      path: '/markup/enterprise/file',
      name: 'MarkupEnterpriseFile',
      meta: { title: '责任人身份信息', type: 'user' },
      component: () => import('@/views/markup/enterprise/file')
    },
    {
      path: '/markup/enterprise/notification',
      name: 'MarkupEnterpriseNotification',
      // meta: { title: '责任告知书', type: 'user' },
      meta: { title: '实名认证隐私政策与责任告知书', type: 'user' },
      component: () => import('@/views/markup/enterprise/notification')
    },
    {
      path: '/markup/enterprise/agreement',
      name: 'MarkupEnterpriseAgreement',
      meta: { title: '入网协议', type: 'user' },
      component: () => import('@/views/markup/enterprise/agreement')
    },
    {
      path: '/markup/enterprise/result',
      name: 'MarkupEnterpriseResult',
      meta: { title: '校验结果', type: 'user' },
      component: () => import('@/views/markup/enterprise/result')
    }
  ]
}

export default router



// WEBPACK FOOTER //
// ./src/router/enterprise-markup.js